import Api from './ApiRequest';

export default {
    insert: (data) => Api.post('/training/compliance', data),
    get: (complianceId) => Api.get(`/training/compliance/${complianceId}`),
    list: (params = null) => Api.get('/training/compliances', params),
    update: (complianceId, data) => Api.put(`/training/compliance/${complianceId}`, data),
    delete: (complianceId) => Api.delete(`/training/compliance/${complianceId}`),
    listProgress: (complianceId, params = null) => Api.get(`/training/compliance/${complianceId}/progress`, params),
    assignByFilter: (complianceId, filterId) => Api.post(`/training/compliance/${complianceId}/assign`, {filterId}),
    clearAssignedUsers: (complianceId) => Api.post(`/training/compliance/${complianceId}/clear`)
};